import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-additional-purchase-info',
  templateUrl: './additional-purchase-info.component.html',
  styleUrls: ['./additional-purchase-info.component.scss']
})
export class AdditionalPurchaseInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
